(() => {
  const GAP = 16;
  const isVisible = (el) => {
    const s = getComputedStyle(el);
    const r = el.getBoundingClientRect();
    return s.display !== 'none' && s.visibility !== 'hidden' && Number(s.opacity) > 0 && r.width > 0 && r.height > 0;
  };
  const inSchedule = (root) => {
    const start = root.dataset.start;
    const end = root.dataset.end;
    if (!start || !end) return true;
    const now = new Date();
    const current = now.getHours() * 60 + now.getMinutes();
    const parse = (value) => { const p = value.split(':').map(Number); return p[0] * 60 + p[1]; };
    const a = parse(start); const b = parse(end);
    return a <= b ? current >= a && current <= b : current >= a || current <= b;
  };
  const pathAllowed = (root) => {
    const paths = (root.dataset.hiddenPaths || '').split(/[\n,]+/).map((p) => p.trim()).filter(Boolean);
    return !paths.some((path) => location.pathname.includes(path));
  };
  const update = () => {
    const root = document.querySelector('[data-zs-floating]');
    if (!root) return;
    const clearSideSpace = () => {
      document.documentElement.style.setProperty('--zs-floating-right-clearance', '0px');
      document.documentElement.style.setProperty('--zs-floating-left-clearance', '0px');
    };
    const allowed = inSchedule(root) && pathAllowed(root);
    root.hidden = !allowed;
    root.setAttribute('aria-hidden', String(!allowed));
    if (!allowed) { clearSideSpace(); return; }

    const visibleControls = Array.from(root.querySelectorAll('.zs-flotante__btn')).filter(isVisible);
    if (visibleControls.length) {
      const rootStyle = getComputedStyle(root);
      const sideSpace = `${Math.round(root.getBoundingClientRect().width + GAP)}px`;
      document.documentElement.style.setProperty('--zs-floating-right-clearance', rootStyle.right !== 'auto' ? sideSpace : '0px');
      document.documentElement.style.setProperty('--zs-floating-left-clearance', rootStyle.left !== 'auto' ? sideSpace : '0px');
    } else {
      clearSideSpace();
    }
    const cookieCandidates = document.querySelectorAll('#shopify-pc__banner, .shopify-pc__banner, .cc-window, .cookie-banner');
    let cookieClearance = 0;
    cookieCandidates.forEach((el) => {
      if (!isVisible(el)) return;
      cookieClearance = Math.max(cookieClearance, el.getBoundingClientRect().height + GAP);
    });
    document.documentElement.style.setProperty('--zs-cookie-clearance', `${Math.round(cookieClearance)}px`);

    const candidates = document.querySelectorAll('.zs-prod-sticky.zs-visible, [data-zs-fixed-bottom], #shopify-pc__banner, .shopify-pc__banner, .cc-window, .cookie-banner');
    let clearance = 0;
    candidates.forEach((el) => {
      if (!isVisible(el)) return;
      const r = el.getBoundingClientRect();
      if (r.top >= innerHeight * .4 && r.top < innerHeight) {
        clearance = Math.max(clearance, innerHeight - r.top + GAP);
      }
    });
    const value = `${Math.round(clearance)}px`;
    if (document.documentElement.style.getPropertyValue('--zs-floating-clearance') !== value) {
      document.documentElement.style.setProperty('--zs-floating-clearance', value);
      document.documentElement.style.setProperty('--zs-floating-stack-height', value);
    }
  };
  let frame;
  const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); };
  new MutationObserver(schedule).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'open'] });
  addEventListener('resize', schedule, { passive: true });
  addEventListener('scroll', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('DOMContentLoaded', schedule);
  schedule();
})();
